import React from 'react';
import App from './../app.jsx';

import Home from './../pages/home/home.js';
import LoginV2 from './../pages/login.js';
import { Outlet } from 'react-router-dom';
import AccountList from '../pages/account/accountList.jsx';
import ShipmentForm from '../pages/shipment/shipment.js';
import ShipmentList from '../pages/shipment/shipmentList.js';
import ProvinceList from '../pages/province/provinceList.jsx';
import CityList from '../pages/city/cityList.jsx';
import DistrictList from '../pages/district/districtList.jsx';
import SubDistrictList from '../pages/subdistrict/subdistrictList.jsx';
import OutboundIntegrationLog from '../pages/integration-log-outbound/outboundIntegrationLogList.jsx';
import InboundIntegrationLog from '../pages/integration-log-inbound/inboundIntegrationLogList.jsx';
import CourierList from '../pages/courier/courierList.jsx';
import CourierAreaList from '../pages/courier-area/courierAreaList.jsx';
import ServiceTypeList from '../pages/service-type/serviceTypeList.jsx';
import PackageTypeList from '../pages/package-type/packageTypeList.jsx';
import UserList from '../pages/user/userList.jsx';
import StatusList from '../pages/status/statusList.jsx';
import CourierStatusList from '../pages/courier-status/courierStatusList.jsx';
import CourierServiceTypeList from '../pages/courier-service-type/courierServiceTypeList.jsx';
import ShipmentBulkyUpload from '../pages/shipment/shipmentBulkyUpload.js';

const AppRoute = [
  {
    path: '*',
    element: <App />,
    children: [
      {
        path: 'home',
        element: <Home />
      },
      {
        path: 'shipment/',
        // element: <ShipmentList />,
        children: [
          { path: '', element: <ShipmentList /> },
          { path: ':uid/edit', element: <ShipmentForm /> },
          { path: 'bulky-upload', element: <ShipmentBulkyUpload /> }
        ]
      },
      {
        path: 'integration-log/',
        children: [
          {
            path: 'outbound',
            element: <OutboundIntegrationLog />
          },
          {
            path: 'inbound',
            element: <InboundIntegrationLog />
          }
        ]
      },
      {
        path: 'account',
        element: <AccountList />,
      },
      {
        path: 'area/province',
        element: <ProvinceList />
      },
      {
        path: 'area/city',
        element: <CityList />
      },
      {
        path: 'area/district',
        element: <DistrictList />
      },
      {
        path: 'area/subdistrict',
        element: <SubDistrictList />
      },
      {
        path: 'courier/',
        children: [
          {
            path: '',
            element: <CourierList />
          },
          {
            path: 'area',
            element: <CourierAreaList />
          },
          {
            path: 'service-type',
            element: <CourierServiceTypeList />
          },
          {
            path: 'status',
            element: <CourierStatusList />
          },
        ],
      },
      {
        path: 'master-data/',
        children: [
          {
            path: 'service-type',
            element: <ServiceTypeList />
          },
          {
            path: 'status',
            element: <StatusList />
          },
          {
            path: 'package-type',
            element: <PackageTypeList />
          }, 
        ]

      }, 
      {
        path: 'user/',
        children: [
          {
            path: '',
            element: <UserList />
          },
        ]
      },
      {
        path: 'login',
        element: <LoginV2 />
      },

    ]
  }
];


export default AppRoute;